import React, { Component, PropTypes } from 'react';
import { mixin, RefluxMixin } from 'Util';
import { StoreOverviewStore, AuthStore } from 'stores';
import KlarnaCheckoutForm from 'components/Store/KlarnaCheckoutForm';
import { getCart } from 'selectors/store';

class KlarnaCheckoutFormContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    // this.listenToStoreWithMapper(KlarnaStore, state => ({
    //   ...state
    // }));
    this.listenToStoreWithMapper(AuthStore, state => ({
      loggedIn: state.loggedIn
    }));

    this.listenToStoreWithMapper(StoreOverviewStore, state => ({
      cart: getCart(state),
      store: state.name,
      method: state.payment.method,
      discountCode: state.discountCode,
      paymentLoading: state.payment.loading,
      snippet: (state.payment.data && state.payment.data.snippet) || ''
    }));
  }

  render() {
    return <KlarnaCheckoutForm {...this.state} {...this.props} />;
  }
}

export default KlarnaCheckoutFormContainer;



// WEBPACK FOOTER //
// ./src/js/containers/Store/KlarnaCheckoutForm.js